import { HoverTaxTooltip } from '../../utility/helpers/commonFunction';
import TaxBreakdownCard from './TaxBreakdownCard';

/**
 * Wraps a read-only payment-summary tax label with the "Applicable X of N" hover card, mirroring
 * the editable payment summary (MultiTaxRows). `summary` is one row from summarizeTaxFromRecord().
 *
 * The card shows on EVERY applied tax row, not just line-customized ones — same as the editor,
 * where hovering any tax name opens it. It is informational: "how did this tax total come about".
 * Gating it on `customized` would have made the detail pages silently drop the breakdown for the
 * common case (tax applied to every line), which is exactly when users still want to see the
 * taxable base behind the number.
 *
 * Renders nothing extra when there is no summary — the label passes through untouched.
 *
 * placement="left" + the pointer cursor match MultiTaxRows, so the card opens on the same side and
 * reads as the same affordance whether the document is being edited or just viewed.
 */
const TaxSummaryHover = ({ summary, children }) => {
    if (!summary) return children;

    return (
        <HoverTaxTooltip title={<TaxBreakdownCard summary={summary} />} placement="left" arrow>
            <span style={{ display: 'inline-flex', cursor: 'pointer' }}>{children}</span>
        </HoverTaxTooltip>
    );
};

export default TaxSummaryHover;
